// extracted by mini-css-extract-plugin
export default {"message":"Message_message_GfZEe","toastIcon":"Message_toastIcon_NlQgM"};